import { ReportingTeamUser } from './ReportingTeamUser';
import { User } from './User';

export class TeamProfile {
  user: User;
  reportingTeam: ReportingTeamUser[];
  constructor({ user, reportingTeam }: Record<any, any>) {
    this.user = user;
    this.reportingTeam = reportingTeam !== null ? reportingTeam : [];
  }
}

export const EmptyTeamProfile: TeamProfile = {
  user: {
    userID: '',
    alias: '',
    owner: '',
    firstName: '',
    lastName: '',
    displayName: '',
    userName: '',
    homeRegion: '',
  },
  reportingTeam: [],
};
